import type { MessageType } from "@expert/shared-types";
import type { MultipleActionName, MultipleActions } from "./types";

const TSNR_URL = "https://csp-prod-eastus2-trip-mo.it.att.com/portal/trip_mo/Dashboard_MO";

export function useCreateActions({
    setIsExpanded,
    messageId,
    messageType,
}: {
    setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
    messageId?: string;
    messageType?: MessageType;
}): Record<MultipleActionName, MultipleActions> {
    const eventData = { messageId, messageType };
    return {
        expandMessage: {
            value: "Show more",
            analytics: {
                actionId: "ExpandMessage",
                eventData,
            },
            onClick: () => {
                setIsExpanded(true);
            },
            isVisibleAfterClick: true,
        },
        neutralOrPositiveFeedback: {
            value: ["Issue resolved", "Still need help"],
            analytics: {
                actionId: "MessageFeedbackDetails",
                eventData,
            },
        },
        negativeFeedback: {
            value: "Wrong issue",
            analytics: {
                actionId: "MessageFeedbackDetails",
                eventData,
            },
        },
        tsnr: {
            value: "Open Trip instead",
            analytics: { actionId: "OpenTSNR", eventData },
            onClick: () => {
                window.open(TSNR_URL, "_blank", "noopener,noreferrer");
            },
            isVisibleAfterClick: true,
        },
        additionalPromptActions: {
            value: ["Simplify for beginners", "Give more detail", "Summarize"],
            analytics: {
                actionId: "AdditionalPromptAction",
                eventData,
            },
        },
    };
}
